import { FilterGroup } from 'types';

const useOrderFilters = (): FilterGroup[] => [
  {
    id: 1,
    filters: [
      {
        name: 'customerCode',
        placeholder: 'customer.enterCustomerCode' as const,
        hasClearIcon: true,
      },
    ],
  },
];

export { useOrderFilters };
